import React, { useEffect, useState } from "react";
import ConsentFormsList from "./ConsentFormsList";

const SunshineForms = () => {
  const [page, setPage] = useState<number>(
    parseInt(sessionStorage.getItem("sunshine-page") || "0") ?? 0
  );

  useEffect(() => {
    sessionStorage.setItem("sunshine-page", page.toString());
    return () => {
      sessionStorage.removeItem("sunshine-page");
    };
  }, [page]);

  return <ConsentFormsList formType="sunshine" page={page} setPage={setPage} />;
};

export default SunshineForms;
